import { db } from "../../../config/firebaseconfig"
import forOwn from 'mout/object/forOwn'
import uuid from 'uuid/v1'
import crypto from 'crypto'
import { makeBackupUsername } from './'

/**
 * 
 * @param {object} record the individual student's data row 
 * @param {object} school The school object
 * @param {string} schoolYear The active school year ('2018' for 2018-19, for example)
 * @param {object} classes All of the classes in the school
 * @param {object} teachers All of the teacher in the school
 * @returns {object} the new student created
 */
export default function createStudent (record, school, schoolYear, classes, teachers) {
  // username will be first middle last birthday
  // if username already specified, it will be that

  // check for duplicates (email, username)

  // create student
  // create password or invite
  // add student to classes and teachers
  // create classes if you need to (search by period)
  const subjects = ['english', 'homeroom', 'math', 'science']
  let id = uuid()

  // look through each of the teacher's classes and see if it matches the period
  function matchClass (teacher, period, classes) {
    let output = null
    if (!teacher) return output
    forOwn(teacher.classes, (val, key) => {
      if (val) {
        const thisClass = classes[key]
        if (thisClass.period === period) {
          output = thisClass
        }
      }
    })
    return output
  }

  // generate username in case one isn't already provided in the record
  const backupUsername = makeBackupUsername(record)

  // creates db query for looking for duplicates.
  function getStudentDupCheckQuery (record, backupUsername) {
    const queryType = !!record.email ? 'email' : 'username'
    let username = record.username && record.username.toLowerCase()
    const emailLC = record.email ? record.email.toLowerCase() : ''
    const queries = {
      email: {prop: 'email', val: emailLC},
      username: {prop: 'username', val: username || backupUsername},
    }
    return {...queries[queryType], queryType,}
  }

  // check querySnapshot for duplicates
  function checkForDuplicates(querySnapshot) {
    let is_duplicate = false
    querySnapshot.forEach(doc => {
      if (doc.exists) {
        // duplicate email anywhere is a problem
        if (queryType === 'email') {
          is_duplicate = true
        // so is a duplicate username in same district
        } else {
          if (doc.data().schoolDistrict === school.district) {
            is_duplicate = true
          }
        }
      }
    })
    return is_duplicate
  }

  // check for student duplicate, either by email or username
  const qry = getStudentDupCheckQuery(record, backupUsername)
  const { queryType } = qry
  let studentClassObj = {}
  let studentData
  return db.collection('students').where(qry.prop, '==', qry.val).get()
    .then(querySnapshot => {
      const is_duplicate = checkForDuplicates(querySnapshot)
      if (is_duplicate) {
        // id gets passed out at end. If duplicate, id isn't used
        id = null
        return
      }

      const isEmail = queryType === 'email'
      const secret = 'ncvjrwenvrewjn9123!'

      // init keys
      const inviteId = uuid()
      
      const time = Date.now()
      const batch = db.batch()
      
      // add student to school parent account
      const schoolRef = db.collection('schools').doc(school.id)
      const studentsKey = `students.${id}`
      batch.update(schoolRef, {[studentsKey]: true})

      // add student to each teacher
      const studentTeachers = subjects.map(subject => record[`${subject}teacher`])
      studentTeachers.forEach(tch => {
        if (teachers[tch]) {
          const teachRef = db.collection('educators').doc(teachers[tch].id)
          const studentsKey = `students.${id}`
          batch.update(teachRef, {[studentsKey]: true})
        }
      })

      // add student to each class
      const studentClasses = subjects.map(subject => {
        const teacher = teachers[record[`${subject}teacher`].toLowerCase()]
        return {
          teacher,
          period: record[`${subject}period`],
        }
      })
      studentClasses.forEach(cl => {
        const thisClass = matchClass(cl.teacher, cl.period, classes)
        if (thisClass) {
          studentClassObj[thisClass.id] = true
          const classRef = db.collection('classes').doc(thisClass.id)
          const studentsKey = `students.${id}`
          batch.update(classRef, {[studentsKey]: true})
        }
      })

      // add student to students collection
      const studentRef = db.collection('students').doc(id)
      studentData = {
        id,
        email: isEmail ? qry.val : '',
        username: qry.val,
        firstName: record.First,
        lastName: record.Last,
        fullName: `${record.First} ${record.Last}`,
        state: school.state,
        school: school.id,
        schoolDistrict: school.district,
        lastModified: time,
        created: time,
        role: 'Student',
        sfid: '', 
        validated: !isEmail,
        classes: studentClassObj,
        assessments: {},
      }
      batch.set(studentRef, studentData)

      // add invite if email used instead of username
      if (isEmail) {
        const inviteRef = db.collection('userInvites').doc(inviteId)
        batch.set(inviteRef, {
          id: inviteId,
          userId: id,
          createdDate: time,
          expirationDate: (time + 259200000), 
          firstName: record.First,
          lastName: record.Last,
          email: qry.val,
        })
      }

      // update password if username instead of email
      // the username all lowercase is the password
      if (!isEmail) {
        const passwordRef = db.collection('studentsAuth').doc(id)
        const hash = crypto.createHmac('sha256', secret).update(qry.val).digest('hex')
        studentData.password = qry.val
        batch.set(passwordRef, { id, hash, })
      }

      return batch.commit()
    })
    .then(() => {
      let output = {}
      if (studentData) {
        output.data = studentData
      } else {
        output.error = record
      }
      return output
    })
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/createStudent.js